import axios from 'axios'

export async function saveModerationNotifications (assignModerator: boolean, reportedContentEmails: string[]) {
  return await axios.post('/settings/moderationNotifications/save', {
    assignModerator,
    reportedContentEmails
  })
}
